import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-[360px] bg-white rounded-[2px]" }
const _hoisted_2 = { class: "pt-5 px-6 flex justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-[20px] text-Text/text_high font-gordita-medium" }, "Add API Key", -1)
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-times text-[24px]" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex justify-center items-center w-full" }
const _hoisted_8 = { class: "add-api-key--desc w-full py-5" }
const _hoisted_9 = { class: "gordita-400-11 text-[#374a50] opacity-60 pt-2" }
const _hoisted_10 = { class: "pb-[24px] w-full" }
const _hoisted_11 = { class: "add-api-key-dialog-container-footer pb-3" }
const _hoisted_12 = { class: "flex justify-end w-full pt-3 pr-6" }
const _hoisted_13 = ["data-testid"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Add Key ")

import elementIds from '@/const/elementIds.json';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediField, IncrediButton, useIncrediDialog, useIncrediForm, IncrediSelect } from 'incredi-ui';
import { useApiAccess } from '@/views/settings/settingsApiAccess/settingsApiAccess.helpers';
import { useNotify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import { MAP_COLUMNS_To_Key_Roles, MAP_Key_Roles_To_Show } from '@/views/settings/settingsApiAccess/settingsApiAccess.const';
import { useMatomo } from '@/services/matomo/matomo.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'addAPIKeyDialog',
  setup(__props) {

const { createAPIKey } = useApiAccess();
const { toastMessage } = useNotify();
const matomo = useMatomo();
const { t } = useI18n();
const dialog = useIncrediDialog();
const isProcessingRequest = ref(false);

const closeDialog = () => {
  dialog?.close('addAPIKeyDialog');
};

const { fields, form } = useIncrediForm({
  initialValues: {
    description: '',
    role: MAP_Key_Roles_To_Show.GridAdmin,
  },
  validationSchema: {
    description: (value: any) => value?.length >= 4 && value?.length <= 25,
  },
});

const handleAddNewKey = form.handleSubmit(async () => {
  if (isProcessingRequest.value) return;
  try {
    isProcessingRequest.value = true;
    await createAPIKey(fields.description.value.value, MAP_COLUMNS_To_Key_Roles[fields.role.value.value as keyof typeof MAP_COLUMNS_To_Key_Roles]);
    closeDialog();
    toastMessage(t('settings.apiAccess.addNewKeyDialog.successToastMessage'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  } catch (error) {
    toastMessage(t('settings.apiAccess.addNewKeyDialog.failToastMessage'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  } finally {
    isProcessingRequest.value = false;
    matomo?.trackEvent({ category: 'API Access', action: 'Add key' });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_IncrediForm = _resolveComponent("IncrediForm")!

  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_component_IncrediForm, {
        "data-testid": _unref(elementIds).settings.apiKeys.newKeyDialog.dialog,
        onSubmit: _unref(handleAddNewKey)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", {
                class: "cursor-pointer",
                "data-testid": _unref(elementIds).settings.apiKeys.newKeyDialog.closeDialogButton,
                onClick: closeDialog
              }, _hoisted_6, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(IncrediField), {
                    modelValue: _unref(fields).description.value.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(fields).description.value.value) = $event)),
                    name: "description",
                    label: "Description",
                    maxlength: 25,
                    clearable: "",
                    size: "big",
                    "data-testid": _unref(elementIds).settings.apiKeys.newKeyDialog.addNewKeyInput,
                    onInput: _cache[1] || (_cache[1] = () => _unref(fields).description.validate()),
                    onKeydown: _withKeys(_unref(handleAddNewKey), ["enter"])
                  }, null, 8, ["modelValue", "data-testid", "onKeydown"]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('settings.apiAccess.addNewKeyDialog.hintMessage')), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(IncrediSelect), {
                    modelValue: _unref(fields).role.value.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(fields).role.value.value) = $event)),
                    "data-testid": _unref(elementIds).settings.apiKeys.newKeyDialog.addNewKeyRoleDropDown,
                    items: Object.values(_unref(MAP_Key_Roles_To_Show)),
                    class: "-px-0.5 w-[312px]",
                    size: "big",
                    direction: "bottom-sticky-left",
                    label: "Role"
                  }, null, 8, ["modelValue", "data-testid", "items"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_q_separator),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  "data-testid": _unref(elementIds).settings.apiKeys.newKeyDialog.addNewKeySubmitButton
                }, [
                  _createVNode(_unref(IncrediButton), {
                    class: "add-new-user--add-btn",
                    type: "submit",
                    size: "big",
                    color: "primary",
                    disabled: _unref(fields).description.value.value.length === 0 || !!_unref(form).errors.value.description || isProcessingRequest.value,
                    onClick: _withModifiers(_unref(handleAddNewKey), ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ], 8, _hoisted_13)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["data-testid", "onSubmit"])
    ]),
    _: 1
  }))
}
}

})